<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Promotions</h2>
              <p class="listing-page-desc">Insurance Bazaar</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img
              class="img-fluid"
              alt="icon"
              :src="require('@/assets/images/claim-policy-right-img.svg')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container article-box">
      <div class="in-gift-wrapper" v-if="Object.keys(user).length > 0 && user.chance_become_founder_member == 1 && user.is_founder_member == 0">
        <div class="first-div">
          <img class="img-fluid" :src="require('@/assets/images/promo-gift.svg')" alt="icon" />
        </div>
        <div class="in-flex-one">
          <div class="in-main-heading">Congratulations!</div>
          <div class="title">You are Now Eligible to Get 100% Free Accident &amp; Hospitalization Cover</div>
          <div><p class="text">You Are now Eligible to Get 100% free Accident &amp; Hospitalization cover become Our Founder Member Now! &amp; Also get a chance to win Exclusive Founder Member discount on your Next Policy</p></div>
        </div>
      </div>
      <a class="promotion-link" v-for="(promotion, index) in allPromotions">
        <div class="first-div">
          <img class="img-fluid" :src="require('@/assets/images/promotion_1.svg')" alt />
        </div>
        <div class="in-flex-one">
          <div class="title">{{promotion.title}}</div>
          <div><p class="text">{{promotion.description}}</p></div>
          <div class="d-md-flex align-items-center mt-5" v-if="promotion.promo_code != ''">
            <div class="in-promo-label">Promo Code:</div>
            <div class="promo-field-wrapper2">
              <div class="promo-field">
                <div class="jbl-field">
                  <input type="text" class="jbl-dynamic-input value-text" readonly :value="promotion.promo_code" :id="'promocode'+index">
                </div>
                <button class="promo-apply-btn promo-btn-fixed" @click="copyText(index)"><i class="fa fa-copy" aria-hidden="true"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="read-more">
          <div class="">{{DateDiff(promotion.created_at)}}</div>
<!--          <div><a class="ib-btn-primary" href="javascript:void(0)">Read More</a></div>-->
        </div>
      </a>
      <h2 style="color: rgba(0, 0, 0, 0.3) !important; text-align: center;" v-if="allPromotions.length === 0">No Promotions Found</h2>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading';
  import moment from "moment";

  export default {
    name: "Promotions",
    data () {
      return {
        showLoader: false,
        allPromotions: [],
        user: {}
      }
    },
    components: {
      loading
    },
    created () {
      const self = this;
      self.user = self.$store.getters.getUser;
      self.getPromotions();
    },
    methods: {
      copyText(index) {
        var copyText = document.getElementById('promocode'+index);
        copyText.select();
        document.execCommand('copy');
        $toast.success('Promo Code Copied!', { position: 'top-right' });
      },
      DateDiff(serverDate) {
        const myDate = new Date();
        var a = moment(myDate);
        var b = moment(serverDate);
        var response = '';

        var diff = a.diff(b, 'months');
        response = diff + ' Months Ago';

        if(diff === 0) {
          diff = a.diff(b, 'days');
          response = diff + ' Days Ago';
        }

        if(diff === 0) {
          diff = a.diff(b, 'hours');
          response = diff + ' Hours Ago';
        }

        if (diff === 0) {
          diff = a.diff(b, 'minutes');
          response = diff + ' Minutes Ago';
        }

        return response;
      },
      async getPromotions() {
        const self = this;
        self.showLoader = true;
        await axios.post('promotions').then(function (resp) {
          self.showLoader = false;
          if(resp.data.code == 200) {
            self.allPromotions = resp.data.data;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
          return false;
        })
      }
    }
  };
</script>

<style scoped>
  a.promotion-link {
    font-size: 16px !important;
    font-weight: normal !important;
    line-height: 1.5 !important;
    text-align: left !important;
    color: #c1c1c1 !important;
    text-transform: none !important;
    padding: 13px;
    border-radius: 10px;
    border: solid 1px rgba(55, 141, 171, 0.25);
    background-color: #ffffff;
    display: block;
    margin-bottom: 2rem;
    display: flex;
    position: relative;
    align-items: center;
    flex-flow: row wrap;
  }
  a.promotion-link span {
    position: absolute;
    right: 18px;
    top: 20px;
  }
  .chevron2::before {
    border-style: solid;
    border-width: 0.1em 0.1em 0 0;
    content: '';
    display: inline-block;
    height: 12px;
    left: 0.15em;
    position: relative;
    top: 8PX;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    vertical-align: top;
    width: 12px;
  }
  .chevron2.right:before {
      left: 0;
      transform: rotate(45deg);
  }
  a.promotion-link div.title, .in-gift-wrapper div.title {
    font-family: "Avenir Heavy";
    font-size: 19px;
    /* font-weight: 900; */
    text-align: left;
    text-transform: capitalize;
    color: #5b6770;
  }
  .text {
    font-size: 16px !important;
    font-weight: normal !important;
    line-height: 1.5 !important;
    text-align: left !important;
    color: #c1c1c1 !important;
    margin: 0px;
  }
  .text::first-letter {
    text-transform: capitalize;
  }
  .panel-title > a,
  .panel-title > a:active {
    display: block;
    padding: 1.3rem 2rem;
  }
  .panel-heading a:before {
    content: "\f0d7";
    font-family: "Font Awesome";
    float: right;
    transition: all 0.5s;
    color: #5b6770 !important;
  }
  .first-div {
    margin-right: 22px;
    align-self: baseline !important;
    width: 45px;
    height: 45px;
    position: relative;
    top: 5px;
  }
   .first-div img {
    width: 100%;
    height: 100%;
  }
  a.promotion-link span.time-ago {
    position: absolute;
    right: 20px;
    top: 19%;
    font-family: "Avenir Book";
    font-size: 14px;
    color: #646464;
  }
  .promotion-link p {
    margin: 0px !important
  }
  .in-flex-one {
    flex: 1 !important;
    align-self: baseline !important;

  }
  .read-more{
    display: flex;
    flex-direction: column;
    align-self: baseline;
  }
  .read-more div{
    margin-bottom: 1.3rem;
    }
  .read-more .ib-btn-primary {
    margin-top: 45px;
  }
  .promo-field-wrapper2 {
    min-width: 13.438rem /* 215px */ !important;
  }
  .jbl-field, .promo-field-wrapper2{
    margin-bottom: 0rem !important;
    margin-top: 0rem !important;
  }
  .in-promo-label {
    font-family: "Avenir Book";
    font-size: 15px;
    font-weight: normal;
    color: #ef7c94;
    margin-right: 12px;
  }
  .jbl-field {
    min-height: 42px !important;
  }
  .fa-copy{
    font-size: 21px !important;
    position: relative;
    bottom: 1px;
  }
  .value-text {
    font-size: 1rem;
    position: relative;
    top: 2px;
  }
  .ib-btn-primary {
    padding: 0.7125rem 1.5625rem !important;
  }
  @media (min-width:1100px){
    .in-created-at{
      position: relative;
      bottom: 59px;
      right: -104px;
    }
  }
  .in-gift-wrapper {
  width: 100%;
  min-height: 160px;
  margin: 0 0 30px;
  padding: 15px;
  border-radius: 13px;
  border: dashed 2px #3d9cbd;
  background-color: rgba(61, 156, 189, 0.03);
  display: flex;
  align-items: baseline;
}
.in-main-heading {
  font-family: "Avenir Heavy" !important;
  font-size: 21px !important;
  /* font-weight: 900 !important; */
  font-weight: 500 !important;
  line-height: 1.33 !important;
  color: #845bb3 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Promotions.vue